import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import {
  cityValidator,
  companyNameValidator,
  countryValidator,
  emailValidator,
  insuranceCompanyValidator,
  ocNumberValidator,
  phoneValidator,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  regonValidator,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../utilities/validators";
import { trimmedString } from "../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.PERPETRATOR_COMPANY_DATA]: yup.object({
    [ComponentId.PERPETRATOR_COMPANY_NAME]: trimmedString.onlyIfFieldIsVisible(
      companyNameValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_REGON]: trimmedString.onlyIfFieldIsVisible(
      regonValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_PHONE]: phoneValidator("companyDataphone"),
    [ComponentId.PERPETRATOR_COMPANY_EMAIL]: trimmedString.onlyIfFieldIsVisible(
      emailValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_STREET]: trimmedString.onlyIfFieldIsVisible(
      streetValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_STREET_2]: trimmedString.onlyIfFieldIsVisible(
      streetHouseNumberValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_ZIP_CODE_PL]: trimmedString.onlyIfFieldIsVisible(
      postalCodePolandValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_ZIP_CODE_GENERIC]: trimmedString.onlyIfFieldIsVisible(
      postalCodeGenericValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_CITY]: trimmedString.onlyIfFieldIsVisible(
      cityValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_COUNTRY]: yup
      .object()
      .onlyIfFieldIsVisible(countryValidator),
    [ComponentId.PERPETRATOR_COMPANY_PROVINCE]: trimmedString.onlyIfFieldIsVisibleProvince(
      provinceValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_OC_NUMBER]: trimmedString.onlyIfFieldIsVisible(
      ocNumberValidator
    ),
    [ComponentId.PERPETRATOR_COMPANY_INSURANCE_COMPANY]: trimmedString.onlyIfFieldIsVisible(
      insuranceCompanyValidator
    ),
  }),
};
